import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

// tailwind 클래스 병합
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// 숫자 파싱
export function parseNumber(v: number | string | null | undefined, fallback = 0): number {
  if (v === null || v === undefined) return fallback;
  if (typeof v === "number") return isFinite(v) ? v : fallback;
  const n = parseFloat(String(v).replace(/,/g, "").trim());
  return isFinite(n) ? n : fallback;
}

// 1,234,567 포맷
export function formatNumber(v: number | string) {
  return parseNumber(v).toLocaleString();
}

// 배열 합계
export function sumBy<T extends Record<string, any>>(arr: T[], key: keyof T): number {
  return arr.reduce((acc, r) => acc + parseNumber(r[key] as any), 0);
}

// 퍼센트 포맷
export function formatPercent(v: number | string, digits = 2) {
  const n = parseNumber(v);
  return `${n.toFixed(digits)}%`;
}